import { render, staticRenderFns } from "./AppointSuccess.vue?vue&type=template&id=45df079f&"
import script from "./AppointSuccess.vue?vue&type=script&lang=js&"
export * from "./AppointSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AppointSuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports